import { useNavigate, useLocation } from "react-router-dom";
import castanhaGigante from "../assets/castanhaTriste.png";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  const idioma = location.pathname.startsWith("/en") ? "en" : "pt";

  return (
    <section id="pagina-404">
      <div className="imagem-castanha">
        <img src={castanhaGigante} alt="Castanha gigante" />
      </div>
      <div className="conteudo-404">
        <h1 className="erro">404</h1>
        <p className="mensagem">
          {idioma === "pt"
            ? "Ops! Parece que você se perdeu entre os galhos do cajueiro."
            : "Oops! Looks like you got lost among the cashew branches."}
        </p>
        <button className="botao-voltar" onClick={() => navigate(`/${idioma}`)}>
          {idioma === "pt" ? "Voltar para o Início" : "Back to Home"}
        </button>
      </div>
    </section>
  );
}
